var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHaveFunCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 162,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M-3 0h316v166H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 82V62.492l42.435-6.52 66.405 8.61 47.928-8.133 7.482 1.675 13.564-11.96h34.135l46.52-13.392 27.128 10.042 20.333-5.98L313 24v58H-3z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.556 65.028C-59.69 65.028-121 79.615-121 79.615v86.332H492.381v-97.54c-39.436 0-110.696 16.508-110.696 16.508S300.406 65.861 256.27 65.861c-12.348 0-25.239.703-37.403 1.717-39.75.154-109.19 5.632-109.19 5.632S28.58 65.028-15.556 65.028z",
    fill: "#0181A1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.5,
    cy: 142,
    rx: 45.5,
    ry: 17,
    fill: "#FF8B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.647 129.778l46.176 17.014-3.804 5.31-46.177-17.014 3.805-5.31z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.324 100.613c4.997-9.099 15.897-13.174 25.638-9.586l128.065 47.186c12.035 4.435 17.308 18.536 11.134 29.778-4.996 9.099-15.897 13.175-25.637 9.586l-128.066-47.186c-12.035-4.434-17.307-18.535-11.134-29.778zM110.369 99.624c-4.626-8.68-14.949-12.615-24.179-9.214l-106.826 39.361c-11.202 4.127-16.182 17.194-10.567 27.729 4.626 8.681 14.949 12.615 24.179 9.214l106.826-39.36c11.202-4.128 16.182-17.195 10.567-27.73z",
    fill: "#01496E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.869 129.778l-46.176 17.014 3.804 5.31 46.176-17.014-3.804-5.31z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.264 122.153c-.364-9.275-2.765-24.18-9.696-30.761.103.777.254 1.688.417 2.68 1.007 6.1 2.514 15.234-3.325 14.98-6.789-.295-5.658-6.825-4.243-10.053-6.87 6.412-9.131 17.598-8.763 24.165.005.078.012.155.021.231-.029.424-.044.852-.044 1.285 0 8.59 5.776 15.553 12.901 15.553 7.126 0 12.902-6.963 12.902-15.553 0-.861-.058-1.705-.17-2.527z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.996 125.051c.147-3.235-3.774-7.382-5.753-9.051 0 12.902-9.827 9.051-10.198 11.362-.371 2.311 1.484 11.362 8.35 10.592 6.865-.771 7.417-8.859 7.601-12.903zM226.458 149.254c.071.016.229-.036.299-.019.859-.245 1.444-1.352 1.273-2.367l-2.271-13.659c-.17-1.016-1.074-1.669-1.933-1.424-.859.244-1.444 1.351-1.273 2.367l2.271 13.658c.203.846.896 1.45 1.634 1.444zM213.562 146.685c.072.016.234-.036.306-.02.879-.244 1.478-1.351 1.304-2.367l-2.325-13.658c-.175-1.016-1.101-1.669-1.98-1.425-.88.245-1.479 1.352-1.304 2.367l2.325 13.659c.208.846.918 1.45 1.674 1.444z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.545 144.474s2.493 4.042 1.532 4.562c-.961.52-15.277 6.192-15.618 5.536-1.11-2.32 10.022-8.895 11.221-9.03 1.288-.196 2.509-1.645 2.865-1.068zM215.706 141.907s2.553 4.042 1.568 4.562c-.984.519-15.644 6.191-15.993 5.535-1.136-2.319 10.263-8.895 11.49-9.029 1.32-.196 2.57-1.645 2.935-1.068zM222.183 140.217c1.931-.822 3.821-1.822 5.678-2.661-13.6-46.645 13.573-35.392 39.598-21.998 4.051 2.123 13.24-2.14 15.183-7.359.522-1.487 1.369-3.067 1.817-4.571-34.066-10.858-76.498-21.454-62.276 36.589z",
    fill: "#00183A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.193 137.648c1.978-.821 3.912-1.822 5.815-2.66-13.927-46.645 17.751-37.106 44.401-23.712 4.148 2.124 9.704-.427 11.694-5.645.534-1.487 1.402-3.068 1.861-4.572-34.884-10.857-78.334-21.453-63.771 36.589z",
    fill: "#00183A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.086 86.998l-56.241-7.03M91.726 65.029l52.505 21.347",
    stroke: "#003057",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.723 28.747c1.997-4.235 7.604-7.607 12.447-6.762 4.843.845 7.298 6.365 6.435 11.028-.796 4.62-7.395 10.345-14.771 9.58-4.893-.623-6.715-8.459-4.111-13.846z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.246 41.528c1.482-3.239 5.435-5.751 8.915-5.093 3.481.659 5.163 4.661 4.504 8.141-.658 3.48-6.73 7.627-10.167 7.036-3.412-.701-5.088-6.047-3.252-10.084z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.772 42.995c.065 6.274-4.236 11.4-8.114 11.472-3.809.028-5.713-5.076-5.778-11.35-.064-6.274 3.053-9.5 6.862-9.528 3.809-.03 6.966 3.132 7.03 9.406z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.681 45.165c-.032 1.456-1.396 3.375-2.449 3.374-1.052 0-1.318-1.171-1.354-2.583.031-1.456.868-2.849 1.921-2.848.966-.136 1.802.577 1.882 2.057z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.667 38.978s-1.392-3.996-4.519-5.453c-3.195-1.414-9.227-1.12-10.469 4.453 0 0-.492 4.045 4.432 4.264 4.924.22 3.835-2.246 6.454-.083 2.55 2.206 4.564.257 5.09.784l-.988-3.965z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.626 85.33s-9.946-2.816-12.393-.828c-2.503 2.1 6.445 6.089 13.008 3.629l-.615-2.801z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.035 84.802l.001 3.954c24.605 4.833 36.044 1.643 44.533-23.8 1.349-3.886-.002-4.21-2.821-4.998-.153-.475-.284-.487 0 0-2.82-.79-4.042-.377-5.177 3.33-7.396 24.297-16.324 21.514-36.536 21.514z",
    fill: "#8FCCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.917 97.983c3.889 1.574 7.731 8.141 11.62 7.03 2.87-.833 7.824-1.783 11.99-1.505l-1.851-15.833.648-23.24c0-5-4.074-9.074-9.074-9.074h-4.259c-5 0-9.074 4.074-9.074 9.074l.648 23.333-.648 10.215z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.809 46.195l-6.204-.648c-.093.833-.741 8.889-.463 11.944.185.926 1.759 1.389 3.426.926 1.481-.37 2.592-1.296 2.592-2.13 0-1.759.371-7.13.649-10.092zM287.02 104.36s-8.263 5.746-8.409 8.303c-.145 2.557 8.287-2.083 10.815-7.623l-2.406-.68z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.632 105.705c1.363.963 2.612 1.989 3.887 2.927 15.484-20.736 13.918-34.938-9.001-48.826-3.529-2.152-4.085-.866-5.578 1.695-.611.116-.496.052 0 0-1.405 2.586-1.287 3.87 2.114 5.793 22.177 12.428 18.787 18.974 8.578 38.411z",
    fill: "#8FCCCF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.545,
    height: 11.424,
    rx: 3,
    transform: "scale(-1 1) rotate(83.647 -117.487 -49.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.545,
    height: 11.424,
    rx: 3,
    transform: "scale(1 -1) rotate(68.647 145.74 63.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.655 12h-16.328v18.407c-1.119-.232-2.543-.093-3.917.513-2.543 1.072-3.967 3.17-3.204 4.66.763 1.538 3.408 1.865 5.951.793 2.136-.886 3.51-2.517 3.408-3.915h.102v-16.17h13.988V30.36c-1.119-.186-2.493-.047-3.815.513-2.543 1.072-3.968 3.169-3.205 4.66.763 1.538 3.408 1.864 5.952.792 2.136-.885 3.509-2.516 3.408-3.914V12h-2.34z",
    fill: "#FF8B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.921 12.046h-14.427V30.42c-.992-.233-2.254-.093-3.471.512-2.255 1.07-3.517 3.163-2.841 4.651.677 1.535 3.021 1.86 5.275.79 1.894-.883 3.111-2.51 3.021-3.906h.09V16.326h12.353v14.047c-.991-.186-2.209-.046-3.381.512-2.254 1.07-3.517 3.163-2.84 4.652.676 1.535 3.02 1.86 5.275.79 1.893-.883 3.11-2.511 3.02-3.907V12h-2.074v.046z",
    fill: "#FFA9A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.003 32.193a1.11 1.11 0 00-1.173-.05c-.374.2-.587.548-.587.947v19.464c-1.28-.299-2.826-.1-4.319.697-2.399 1.294-3.572 3.683-2.559 5.326 1.013 1.643 3.786 1.892 6.185.598 1.973-1.046 3.092-2.838 2.879-4.381.053-.1.053-.2.053-.299V35.28c2.24 1.842 5.492 5.227 3.626 7.915-.373.498-.213 1.145.32 1.493.533.349 1.226.2 1.599-.298 3.999-5.675-5.598-11.948-6.024-12.197z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.048 20.444c1.976-.279 3.57-1.673 3.888-3.402 0-.056.128-.056.128 0 .319 1.729 1.912 3.123 3.888 3.402.064 0 .064.112 0 .112-1.976.279-3.57 1.673-3.888 3.402 0 .056-.128.056-.128 0-.319-1.729-1.912-3.123-3.888-3.402-.064 0-.064-.112 0-.112zM192.024 16.46c.988-.199 1.785-1.195 1.944-2.43 0-.04.064-.04.064 0 .159 1.235.956 2.231 1.944 2.43.032 0 .032.08 0 .08-.988.199-1.785 1.195-1.944 2.43 0 .04-.064.04-.064 0-.159-1.235-.956-2.231-1.944-2.43-.032 0-.032-.08 0-.08zM128.036 48.952a3.555 3.555 0 002.916-2.916c0-.048.096-.048.096 0a3.555 3.555 0 002.916 2.916c.048 0 .048.096 0 .096a3.555 3.555 0 00-2.916 2.916c0 .048-.096.048-.096 0a3.555 3.555 0 00-2.916-2.916c-.048 0-.048-.096 0-.096zM295.036 19.952a3.555 3.555 0 002.916-2.916c0-.048.096-.048.096 0a3.555 3.555 0 002.916 2.916c.048 0 .048.096 0 .096a3.555 3.555 0 00-2.916 2.916c0 .048-.096.048-.096 0a3.555 3.555 0 00-2.916-2.916c-.048 0-.048-.096 0-.096zM17.048 20.444c1.976-.279 3.57-1.673 3.888-3.402 0-.056.128-.056.128 0 .319 1.729 1.912 3.123 3.888 3.402.064 0 .064.112 0 .112-1.976.279-3.57 1.673-3.888 3.402 0 .056-.128.056-.128 0-.319-1.729-1.912-3.123-3.888-3.402-.064 0-.064-.112 0-.112z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.858 11.245c-4.96 4.016-6.275 11.19-2.826 16.757 3.448 5.567 10.456 7.585 16.261 4.935a14.55 14.55 0 01-5.087 5.334c-6.862 4.25-15.87 2.133-20.12-4.729-4.25-6.861-2.133-15.87 4.729-20.12a14.544 14.544 0 017.043-2.177z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 58.877,
    width: 28.331,
    height: 16.913,
    rx: 8,
    transform: "rotate(4.841 85.18 58.877)",
    fill: "#417082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.361 99.328c2.2-5.111 8.816-6.471 12.853-2.642l2.479 2.35a8 8 0 01.787 10.746l-.634.807a8 8 0 01-11.233 1.352l-2.394-1.88a8 8 0 01-2.408-9.455l.55-1.278z",
    fill: "#417082"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.934 23.786c0 .901-.223 1.75-.618 2.495 5.618 1.753 10.125 6.565 12.05 12.763l.79.293c0 1.328.033 2.662.09 3.983.083.783.127 1.58.13 2.388.534 8.192 1.88 15.408 2.169 16.896 5.509 6.837 8.941 16.478 8.941 27.161 0 20.735-12.93 28.658-28.88 28.658s-28.88-7.923-28.88-28.658c0-11.28 3.827-21.398 9.885-28.28.403-1.937 1.072-5.968 1.428-12.607a23.125 23.125 0 01.23-7.578c.006-.638.01-1.293.01-1.963l.497-.077a21.632 21.632 0 011.161-3.035 5.332 5.332 0 115.242-6.82c1.701-1.405 3.63-2.474 5.711-3.123a5.332 5.332 0 1110.044-2.496z",
    fill: "#417082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.156 44.174a6.171 6.171 0 016.171-6.171h.79a4.147 4.147 0 014.147 4.147v1.185a7.109 7.109 0 01-7.109 7.108 3.999 3.999 0 01-3.999-3.998v-2.271z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.038,
    cy: 38.892,
    r: 2.222,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.494,
    cy: 31.339,
    r: 2.666,
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93 89.543c0-10.674 3.879-20.883 8.664-20.883s8.664 10.209 8.664 20.883-3.88 12.885-8.664 12.885c-4.785 0-8.664-2.211-8.664-12.885z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19 108.609a7.999 7.999 0 018.343.71l4.226 3.117c4.258 3.142 4.348 9.478.18 12.739l-.952.744a8 8 0 01-9.588.202l-4.518-3.236c-4.89-3.503-4.31-10.948 1.065-13.65l1.244-.626zM32.558 81.892c-.749-2.244.15-4.591 1.833-6.254l13.127-12.97a7.851 7.851 0 0112.552 9.07l-8.494 17.138c-.759 1.53-1.99 2.82-3.664 3.158-2.27.457-5.81.52-9.446-1.958-3.358-2.29-5.059-5.637-5.908-8.184z",
    fill: "#417082"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6 115.777V99.772c.09-2.538-1.923-7.612-10.71-7.612-8.786 0-11.166 12.142-11.257 18.214v8.698h20.87v.001h5.493a3.296 3.296 0 00-3.295-3.296h-1.102z",
    fill: "#7FA7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.151 119.073c0-.583.203-1.142.563-1.554.361-.412.85-.643 1.36-.643.51 0 .999.231 1.36.643.36.412.562.971.562 1.554h-3.844zM34.757 119.073c0-.583.203-1.142.563-1.554.36-.412.85-.643 1.36-.643.51 0 .998.231 1.358.643.361.412.564.971.564 1.554H34.757zM23.773 119.073c0-.583.202-1.142.563-1.554.36-.412.85-.643 1.359-.643.51 0 .999.231 1.36.643.36.412.562.971.562 1.554h-3.844z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.873 111.109c.2 5.273 5.89 7.506 8.71 7.964l1.245-1.922c-2.24-1.831-6.37-6.317-4.977-9.612 1.393-3.295-.25-5.767-1.245-6.591.996.824.747 3.021.747 2.472 0-.44-.83-1.099-1.244-1.373-2.39-1.978-7.135-.641-9.209.274 1.394-.439 3.9 1.282 4.978 2.197l-2.24 1.099c.995-.366 3.036.219 3.235 5.492z",
    fill: "#7FA7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.647 105.616c1-.376 3.05.352 3.25 5.767l1.251-2.256.5.282 1-.846h.998l1.25-.846c1.398-3.385-.012-5.945-1.25-6.665.545.605.663 1.87.686 2.309-.061-.444-.787-1.015-1.186-1.285-2.399-2.031-7.163-.695-9.245.245 1.4-.451 3.86 1.257 4.943 2.197l-2.197 1.098z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.668,
    ry: 10.71,
    transform: "matrix(-1 0 0 1 33.933 103.969)",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.136 101.748a3 3 0 004.736 0l1.477-1.898 7.14-9.886 5.492-17.026L42.9 78.316H32.109l-11.082-5.378 5.493 17.026 7.14 9.886 1.476 1.898z",
    fill: "#7FA7B6"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.648,
    transform: "matrix(-1 0 0 1 37.505 102.596)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.098,
    transform: "matrix(-1 0 0 1 33.109 88.315)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.098,
    transform: "matrix(-1 0 0 1 41.898 88.315)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.762 83.373l3.57-8.513-7.964 4.394 4.394 4.12zM26.52 83.373l-3.57-8.513 7.963 4.394-4.394 4.12zM33.66 98.938v.911l-7.14-9.886a9.211 9.211 0 017.14 8.975zM41.352 98.938v.911l7.14-9.886a9.211 9.211 0 00-7.14 8.975z",
    fill: "#CFF8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 155,
    y1: 0,
    x2: 155,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0181A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#7DE3F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h308v162H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHaveFunCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/have-fun-card.139828e61a3d39a834a1a069fb2af332.svg";